import { parseDynamicTableData } from './dynamic-table-data-layer'
import { hotModuleReload } from '../../../components/common/utilities/hot-module-reload'

declare global {
  interface Window {
    dataLayer: object[]
  }
}

window.addEventListener('DOMContentLoaded', () => {
  window.dataLayer = window.dataLayer || []
  const dynamicTableData = parseDynamicTableData()
  if (dynamicTableData) {
    window.dataLayer.push(dynamicTableData)
  }
})

hotModuleReload()
